import { DropdownMenuContentProps } from '@radix-ui/react-dropdown-menu';
import { forwardRef } from 'react';
import { StyledContent } from '../dropdown.styled';

export const Content = forwardRef<HTMLDivElement, DropdownMenuContentProps>(
  (props, forwardedRef) => {
    return (
      <StyledContent
        ref={forwardedRef}
        sideOffset={4}
        collisionPadding={16}
        {...props}
      />
    );
  }
);
